<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="icon-spinner" viewBox="0 0 61 61"><path d="M37.48,52.946a23.5,23.5,0,1,1,16.4-24.786l7.081.9a30.5,30.5,0,1,0-19.3,29.823" /></svg>
</template>
